import React, {useRef, useEffect, useCallback, useMemo, useState} from 'react';
import CaptivateImageGrid from '../../CaptivateImagesGrid/CaptivateImageGrid/CaptivateImageGrid';
import CaptivateWideImageModal from '../../CaptivateImagesGrid/CaptivateAllImageModal/CaptivateWideImageModal';
import HomeStayGalleryAllImageHeader from './HomeStayGalleryAllImageHeader';

//utils
import {transformCdnImage} from '@stencil/hotels-utils/src/common-utils';

import * as S from './HomeStayGallery.styles';

const defaultImageSize = {
  with: 704,
  height: 409,
};

const HomeStayGalleryAllMediaImages = ({
  selectedRoom = {},
  imageGridDataListArrays = [],
  maxImageGridType = 8,
  mode = 'fixed',
  setSelectedRoom = obj => {},
}) => {
  const wrapperRef = useRef(null);
  const [carouselState, updateCarouselState] = useState({isOpen: false, imageNo: ''});

  const handlerUpdateSelectedRoom = useCallback(
    imageNo => {
      setSelectedRoom({...selectedRoom, selectedImageNo: imageNo});
    },
    [setSelectedRoom],
  );
  const handlerOnPrevNextImage = useCallback(
    ({page}) => {
      handlerUpdateSelectedRoom({isOpen: true, imageNo: page});
    },
    [handlerUpdateSelectedRoom],
  );

  const handleCloseModal = useCallback(() => {
    setSelectedRoom(null);
  }, []);

  useEffect(() => {
    if (wrapperRef?.current) {
      wrapperRef?.current.scrollIntoView({behavior: 'smooth', inline: 'nearest'});
    }
  }, [wrapperRef.current]);

  const currentImageData = useMemo(() => {
    const {media = [], selectedImageNo} = selectedRoom || {};
    const {imageNo} = selectedImageNo || {};

    const currentImageUrl = media?.find(d => d.imageNo === imageNo)?.gallery_url || '';

    return {
      currentImage: currentImageUrl
        ? transformCdnImage(currentImageUrl, defaultImageSize.with, defaultImageSize.height)
        : '',
    };
  }, [selectedRoom?.media, selectedRoom?.selectedImageNo?.imageNo]);

  return (
    <S.HomeStayGalleryAllMediaImagesWrapper ref={wrapperRef}>
      <HomeStayGalleryAllImageHeader
        headerType={'taggedMedia'}
        overviewData={selectedRoom}
        gridType={8}
        handlerBackClick={() => setSelectedRoom(null)}
      />
      <CaptivateImageGrid
        imageGridDataListArrays={imageGridDataListArrays}
        maxImageGridType={maxImageGridType}
        mode={mode}
        updateCarouselState={handlerUpdateSelectedRoom}
        showHeader={false}
      />
      {selectedRoom?.selectedImageNo?.isOpen && (
        <S.WideImageModalWrapper>
          <CaptivateWideImageModal
            carouselState={carouselState}
            data={imageGridDataListArrays?.flat()}
            updateCarouselState={handlerUpdateSelectedRoom}
          />
        </S.WideImageModalWrapper>
      )}
    </S.HomeStayGalleryAllMediaImagesWrapper>
  );
};

export default HomeStayGalleryAllMediaImages;
